import { render } from "./LoadingSkeleton.vue?vue&type=template&id=be8c148c&ts=true"
import script from "./LoadingSkeleton.vue?vue&type=script&lang=ts"
export * from "./LoadingSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__